import { render, staticRenderFns } from "./Q13.vue?vue&type=template&id=9e49d852&"
import script from "./Q13.vue?vue&type=script&lang=ts&"
export * from "./Q13.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports